import styled, { css } from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { ExpansionModeAttr } from './model';

export const CartSection = styled.aside``;

export const CartBox = styled.div`
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderMedium')};
    background: ${getPurpurColor('backgroundPrimary')};
    overflow: clip;
`;

export const CartFooter = styled.section`
    background: ${getPurpurColor('backgroundSecondary')};
    margin: 0;
    ${purpurMedia('sm')`
        padding-bottom: ${getPurpurSpacing('250')};
    `}
    ${purpurMedia('md')`
        padding-bottom: ${getPurpurSpacing('300')};
    `}
`;

type ExpandAttr = { $isExpanded?: boolean };

const expansionMixin = css<ExpandAttr>(
    ({ $isExpanded }) =>
        $isExpanded !== undefined &&
        css`
            display: grid;
            transition: grid-template-rows ${getPurpurMotion('duration200')} ${getPurpurMotion('easingEaseInOut')};
            visibility: ${$isExpanded ? 'visible' : 'collapse'};
            grid-template-rows: ${$isExpanded ? '1fr' : '0fr'};
        `,
);
const expansionUnsetMixin = css`
    visibility: visible;
    grid-template-rows: 1fr;
`;

export const EntryList = styled.div.attrs({ role: 'list' })<ExpansionModeAttr & ExpandAttr>(
    ({ $expansionMode }) => {
        switch ($expansionMode) {
            case 'ALWAYS':
                return expansionMixin;
            case 'MOBILE_ONLY':
                return css`
                    ${expansionMixin}
                    ${purpurMedia('md')`${expansionUnsetMixin}`}
                `;
            case 'NEVER':
            default:
                return null;
        }
    },
    css`
        background: ${getPurpurColor('backgroundPrimary')};
        margin: 0;
    `,
);
export const ExpandableBody = styled.div`
    overflow-y: hidden;
`;

export const sideSpacingOfHeaderFooter = css`
    ${purpurMedia('sm')`
        padding-left: ${getPurpurSpacing('200')};
        padding-right: ${getPurpurSpacing('200')};
    `}
    ${purpurMedia('md')`
        padding-left: ${getPurpurSpacing('200')};
        padding-right: ${getPurpurSpacing('200')};
    `}
    ${purpurMedia('lg')`
        padding-left: ${getPurpurSpacing('300')};
        padding-right: ${getPurpurSpacing('300')};
    `}
`;

export const sideSpacingOfEntries = css`
    ${purpurMedia('sm')`
        padding-left: ${getPurpurSpacing('150')};
        padding-right: ${getPurpurSpacing('150')};
    `}
    ${purpurMedia('lg')`
        padding-left: ${getPurpurSpacing('300')};
        padding-right: ${getPurpurSpacing('300')};
    `}
`;

export const CtaGroup = styled.div`
    ${sideSpacingOfHeaderFooter};
    &:not(:empty) {
        margin-top: ${getPurpurSpacing('300')};
    }

    display: flex;
    gap: ${getPurpurSpacing('200')};

    flex-direction: column;
    ${purpurMedia('md')`
        flex-direction: row;
    `}
`;
